// url 두개 합치기 with 서치파람
export const  mergeSearchParams = (url1:string, url2:string, base?:string) => {
  const currentBase = location.href;

  // 두 URL의 searchParams 객체를 생성
  const searchParams1 = new URL(url1, currentBase).searchParams;
  const searchParams2 = new URL(url2, currentBase).searchParams;

  // 두 번째 URL의 searchParams 항목들을 첫 번째 URL의 searchParams에 추가
  for (const [key, value] of searchParams2.entries()) {
    searchParams1.set(key, value);
  }

  // 새로운 URL 객체를 생성하고, 첫 번째 URL의 searchParams를 업데이트
  const newUrl = new URL(url1, currentBase);
  newUrl.search = searchParams1.toString();

  // 새로운 URL 문자열을 반환
  return newUrl.toString();
};

// a 태그에 현재의 서치파람 넣기
export const setAnchorTagWithParams = (Elements: HTMLAnchorElement) => {
    const curHref = Elements.getAttribute('href');
    if(curHref){
      const newUrl = mergeSearchParams(curHref,location.href );
      Elements.setAttribute('href', newUrl);
      console.log(curHref, newUrl);
    }
};

// 특정 서치 파람 제거
export const removeQueryParam = (url: string, searchParam: string) => {
  // URL을 분석하기 위해 URL 객체 생성
  const urlObj = new URL(url);

  // searchParam 제거
  urlObj.searchParams.delete(searchParam);

  // 변경된 URL 반환
  return urlObj.toString();
};
